import request from './request'

export function getConfig() {
  return request.get('/Main/getConfig')
}
